import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT_META = {
  title: "Skhool.in - India First AI School Management System (Free of Cost)",
  description:
    "Skhool.in is an India-first AI school management system. Start free of cost and digitize admissions, attendance, fees, exams, communication, and school operations.",
};

const ROUTE_META = [
  {
    match: (p) => p === "/" || p === "/hello",
    title: "Skhool.in - India First AI School Management System (Free of Cost)",
    description:
      "Skhool.in is an India-first AI school management system. Start free of cost and digitize admissions, attendance, fees, exams, communication, and school operations.",
  },
  {
    match: (p) => p === "/login",
    title: "School Login - Admin, Teacher, Student Access | Skhool.in",
    description:
      "Secure school login for admins, teachers, and students with role-based access on Skhool.in.",
  },
  {
    match: (p) => p === "/school-owner/register",
    title: "Register Your School - Start Free | Skhool.in",
    description:
      "Register your school on Skhool.in and start AI-powered digital school operations with a free onboarding plan.",
  },
  {
    match: (p) => p === "/pricing",
    title: "Pricing Plans - Free and Scalable School ERP Plans | Skhool.in",
    description:
      "Explore Skhool.in pricing plans, including free options and student-based plans for growing schools in India.",
  },
  {
    match: (p) => p === "/forgot-password",
    title: "Forgot Password - Recover School Account | Skhool.in",
    description:
      "Recover your Skhool.in login securely and regain access to your school management account.",
  },
  {
    match: (p) => p === "/privacy-policy",
    title: "Privacy Policy | Skhool.in",
    description:
      "Read Skhool.in privacy policy for data handling, security, and user privacy commitments for schools.",
  },
  {
    match: (p) => p === "/terms-of-service",
    title: "Terms of Service | Skhool.in",
    description:
      "Read terms of service for using Skhool.in school management platform and applications.",
  },
  {
    match: (p) => p === "/courses",
    title: "Courses and Academics | Skhool.in",
    description:
      "Showcase school courses, academics, and curriculum details with Skhool.in website modules.",
  },
  {
    match: (p) => p === "/gallery",
    title: "School Gallery - Events and Campus Photos | Skhool.in",
    description:
      "Display school events, activities, and campus moments with Skhool.in gallery management tools.",
  },
  {
    match: (p) => p === "/contact" || p === "/page/contact",
    title: "Contact School | Skhool.in",
    description:
      "Contact school administration for admissions, support, and general queries via Skhool.in contact page.",
  },
];

const ensureMetaTag = (name) => {
  let tag = document.head.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  return tag;
};

const ensurePropertyTag = (property) => {
  let tag = document.head.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  return tag;
};

const ensureCanonical = () => {
  let link = document.head.querySelector("link[rel='canonical']");
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  return link;
};

const SeoRouteManager = () => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    const canonicalMap = {
      "/page/home": "/",
      "/page/about": "/about",
      "/page/academics": "/academics",
      "/page/admissions": "/admissions",
      "/page/facilities": "/facilities",
      "/page/announcements": "/announcements",
      "/page/careers": "/careers",
      "/page/contact": "/contact",
      "/page/results": "/results",
      "/page/news": "/news",
    };
    const canonicalPath = canonicalMap[currentPath] || currentPath;
    const selected = ROUTE_META.find((entry) => entry.match(currentPath)) || DEFAULT_META;

    document.title = selected.title;

    const descriptionTag = ensureMetaTag("description");
    descriptionTag.setAttribute("content", selected.description);

    const ogTitle = ensurePropertyTag("og:title");
    ogTitle.setAttribute("content", selected.title);

    const ogDescription = ensurePropertyTag("og:description");
    ogDescription.setAttribute("content", selected.description);

    const twitterTitle = ensureMetaTag("twitter:title");
    twitterTitle.setAttribute("content", selected.title);

    const twitterDescription = ensureMetaTag("twitter:description");
    twitterDescription.setAttribute("content", selected.description);

    const canonical = ensureCanonical();
    canonical.setAttribute("href", `https://www.skhool.in${canonicalPath}`);
  }, [location.pathname]);

  return null;
};

export default SeoRouteManager;
